<template>
  <div>
    <div class="top_img_content">
      <div class="about_img1">
        <div class="about_title">
          一站式科研服务平台
          <div class="about_menu">
            <span class="about_menu_item">国企控股</span>
            <span class="about_menu_item">设备丰富</span>
            <span class="about_menu_item">技术精湛</span>
            <span class="about_menu_item">快捷服务</span>
          </div>
        </div>
      </div>
    </div>
    <div class="about_us">
      <div class="about_us_main">
        <div class="about_us_left">
          <div class="about_us_title">
            <div class="en">ABOUT US</div>
            <div class="cn">走进纳微</div>
          </div>
          <div class="garp"></div>
          <div class="about_us_content">
            湖南纳微新材料科技有限公司成立于2018年6月，注册资本750万元，是一家专注于科研服务及材料检测的高新技术企业。于2021年底被湘江集团大科城公司注资控股，旗下品牌纳微创新是湖南大型的一站式科研服务平台，提供材料检测、生物检测、高分子检测、金属检测、模拟计算、科研绘图等全方位的科研服务。
          </div>
          <div class="about_us_num">
            <div class="about_us_num_item">
              <div class="top">
                <span style="font-size: 26px; color: #4f5de3">7500</span
                ><span style="color: #4f5de3; padding-left: 3px">万+</span>
              </div>
              <div class="text">自营设备</div>
            </div>
            <div class="about_us_num_item dash">
              <div class="top">
                <span style="font-size: 26px; color: #4f5de3">100000</span
                ><span style="color: #4f5de3">位</span>
              </div>
              <div class="text">服务科研工作者</div>
            </div>
            <div class="about_us_num_item">
              <div class="top">
                <span style="color: #4f5de3">超</span
                ><span style="font-size: 26px; color: #4f5de3">800</span
                ><span style="color: #4f5de3">家</span>
              </div>
              <div class="text">服务企业</div>
            </div>
          </div>
        </div>
        <div class="about_us_right">
          <div id="mse"></div>
          <!-- <video src="../../assets/video/xuanchuan.mp4"></video> -->
        </div>
      </div>
    </div>
    <div class="service">
      <div class="service_main">
        <div class="service_title">
          <div class="en">SERVICE</div>
          <div class="cn">核心业务</div>
          <div class="garp"></div>
        </div>
        <div class="service_main_menu">
          <div class="service_main_menu__item one" @click="toUrl('https://www.navi-sci.cn/materialTest?type=2')">
            <div>材料检测</div>
          </div>
          <div class="service_main_menu__item two" @click="toUrl('https://www.navi-sci.cn/lifeSciences?type=5')">
            <div>试剂耗材</div>
          </div>
          <div class="service_main_menu__item three" @click="toUrl('https://www.navi-sci.cn/scientificDraw?type=8')">
            <div>科研服务</div>
          </div>
        </div>
      </div>
    </div>
    <div class="honor">
      <div class="honor_main">
        <div class="honor_title">
          <div class="en">HONOR</div>
          <div class="cn">荣誉证书</div>
        </div>
        <div class="grap"></div>
        <div class="honor_main_menu">
          <div class="honor_main_menu__item one">
            <img src="../../assets/img/ryzs1ab.png" alt="" />
          </div>
          <div class="honor_main_menu__item two">
            <img src="../../assets/img/ryzs2ab.png" alt="" />
          </div>
          <div class="honor_main_menu__item three">
            <img src="../../assets/img/ryzs3ab.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="case">
      <div class="case_main">
        <div class="case_title">
          <div class="en">CASE</div>
          <div class="cn">经典案例</div>
        </div>
        <div class="grap"></div>
        <div class="case_content">
          <img src="../../assets/img/caseab.png" alt="" />
        </div>
      </div>
    </div>
    <div class="partner">
      <div class="partner_main">
        <div class="partner_title">
          <div class="en">PARTNER</div>
          <div class="cn">合作客户</div>
        </div>
        <div class="one">
          <img src="../../assets/img/oneab.png" alt="" />
        </div>
        <div class="tow">
          <img src="../../assets/img/twoab.png" alt="" />
        </div>
        <div class="three">
          <img src="../../assets/img/threeab.png" alt="" />
        </div>
        <div class="four">
          <img src="../../assets/img/fourab.png" alt="" />
        </div>
        <div class="five">
          <img src="../../assets/img/fiveab.png" alt="" />
        </div>
        <div class="six">
          <img src="../../assets/img/sixab.png" alt="" />
        </div>
        <div class="seven">
          <img src="../../assets/img/sevenab.png" alt="" />
        </div>
        <div class="eight">
          <img src="../../assets/img/eightab.png" alt="" />
        </div>
        <div class="nine">
          <img src="../../assets/img/nineab.png" alt="" />
        </div>
        <div class="ten">*排名不分先后</div>
        <div class="garp"></div>
      </div>
    </div>
    <div class="news">
      <div class="news_main">
        <div class="news_title">
          <div class="en">NEWS</div>
          <div class="cn">社会责任</div>
        </div>
        <div class="grap"></div>
        <div class="news_main_menu">
          <div class="news_item">
            <div class="news_header">
              <img src="../../assets/img/news1ab.jpg" alt="" />
            </div>
            <div class="new_body">
              <div class="new_date">
                <div class="new_day">08</div>
                <div class="new_year">2023-04</div>
              </div>
              <div class="new_content">
                《人民日报》刊发的《湖南加力推进科技创新（新时代新征程新伟业•坚定不移推动高质量发展）》中，湖南纳微新材料科技有限公司被点名。
              </div>
            </div>
          </div>
          <div class="news_item">
            <div class="news_header">
              <img src="../../assets/img/news2ab.jpg" alt="" />
            </div>
            <div class="new_body">
              <div class="new_date">
                <div class="new_day">17</div>
                <div class="new_year">2023-04</div>
              </div>
              <div class="new_content">
                《湖南卫视》报道《稳增长 促发展强信心
                湖南：加力推进科技创新构建战略科技力量》中，湖南纳微新材料科技有限公司被点赞。
              </div>
            </div>
          </div>
          <div class="news_item">
            <div class="news_header">
              <img src="../../assets/img/news3ab.jpg" alt="" />
            </div>
            <div class="new_body">
              <div class="new_date">
                <div class="new_day">04</div>
                <div class="new_year">2023-12</div>
              </div>
              <div class="new_content">
                《长沙新闻综合频道》报道《全力建设全球研发中心城市|
                纳微新材：今年已完成30多万分新材料样品分析检测》中，对湖南纳微新材料科技有限公司进行报道。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Player from "xgplayer";
import "xgplayer/dist/index.min.css";
import video from "@/assets/video/xuanchuan.mp4";
export default {
  created() {
    this.$nextTick(() => {
      let player = new Player({
        id: "mse",
        url: video,
        height: "450px",
        width: "800px",
        autoplay: true,
        autoplayMuted: true,
        loop: true,
        miniprogress: false,
        controls: false,
      });
    });
  },
  methods:{
    toUrl(url){
      window.location.href = url
    },
  }
};
</script>
<style scoped lang="scss">
.about_img1 {
  width: 100%;
  height: 450px;
  max-width: 1920px;
  margin: 0 auto;
  padding-top: 10px;
  background: url("../../assets/img/banner_about.jpg") no-repeat;
  background-size: 100% 100%;
}
.about_title {
  color: #fff;
  font-size: 70px;
  letter-spacing: 10px;
  font-weight: 500;
  line-height: 90px;
  padding-left: 10%;
  padding-top: 115px;
}
.about_menu {
  font-size: 24px;
  line-height: 18px;
  letter-spacing: 1px;
  font-weight: normal !important;
  display: flex;
  padding-top: 20px;
}
.about_menu_item {
  display: block;
  width: 135px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ffffff;
  margin-right: 52px;
  border-radius: 6px;
}
.about_us {
  width: 100%;
  background: #ffffff;
}
.about_us_main {
  max-width: 1920px;
  margin: 0 auto;
  padding: 80px 0;
  display: flex;
  min-width: 1400px;
  justify-content: space-around;
  .about_us_left {
    width: 30%;
    padding: 0 20px;
    padding-top: 50px;
    .about_us_title {
      .en {
        font-size: 35px;
        color: #dddddd;
        line-height: 28px;
      }
      .cn {
        font-size: 39px;
        color: #4f5de3;
        letter-spacing: 6px;
        font-weight: bold;
      }
    }
    .garp {
      border-bottom: 1px solid #eeeeee;
      position: relative;
    }
    .garp::after {
      display: block;
      position: absolute;
      content: "";
      width: 80px;
      height: 2px;
      background-color: #4f5de3;
      left: 0;
      top: 0;
    }
    .about_us_content {
      color: #575757;
      font-size: 14px;
      line-height: 24px;
      letter-spacing: 1.5px;
      text-indent: 2em;
      padding-top: 20px;
    }
    .about_us_num {
      display: flex;
      // justify-content: center;
      .dash {
        border-left: 1px dashed #7b7b7b;
        border-right: 1px dashed #7b7b7b;
      }
      .about_us_num_item {
        padding: 0 40px;
        width: 200px;
        margin: 20px 0;
        .text {
          font-size: 14px;
          color: #333;
        }
      }
    }
  }
  .about_us_right {
    width: 40%;
    video {
      width: 500px;
      height: 500px;
      margin-top: -55px;
    }
  }
}
.service {
  width: 100%;
  background: #fff;
}
.service_main {
  max-width: 1920px;
  background: url("../../assets/img/hexinyewu.jpg");
  margin: 0 auto;
  height: 1000px;
  .service_title {
    height: 180px;
    padding-left: 150px;
    .en {
      font-size: 35px;
      color: #4e5d6e;
      line-height: 28px;
      padding-top: 100px;
      line-height: 50px;
    }
    .cn {
      font-size: 39px;
      color: #ffffff;
      letter-spacing: 2px;
      font-weight: bold;
    }
  }
  .garp {
    width: 70px;
    height: 3px;
    background: #ffffff;
    margin-top: 15px;
  }
  .service_main_menu {
    display: flex;
    margin-top: 140px;
    justify-content: center;
    .one {
      background: url("../../assets/img/cljcab.jpg");
    }
    .two {
      background: url("../../assets/img/sjhcab.jpg");
      margin: 0 20px;
    }
    .three {
      background: url("../../assets/img/kyfwab.jpg");
    }
    .service_main_menu__item {
      width: 400px;
      height: 532px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 30px;
      color: #fff;
      cursor: pointer;
    }
  }
}
.honor {
  width: 100%;
  background: #ffffff;
}
.honor_main {
  max-width: 1920px;
  margin: 0 auto;
  height: 600px;
  .honor_title {
    height: 180px;
    padding-left: 150px;
    .en {
      font-size: 35px;
      color: #dbdbdb;
      padding-top: 60px;
      line-height: 40px;
    }
    .cn {
      font-size: 39px;
      color: #5373f8;
      letter-spacing: 1px;
      font-weight: bold;
    }
  }
  .grap {
    width: 70px;
    height: 3px;
    background: #5373f8;
    margin-top: -15px;
    margin-left: 150px;
  }
  .honor_main_menu {
    display: flex;
    min-width: 1400px;
    width: 85%;
    margin: 0 auto;
    padding-top: 40px;
    .honor_main_menu__item {
      width: 600px;
      height: 350px;
    }
    .one {
      img {
        width: 404px;
        height: 265px;
        margin-top: 35px;
      }
    }
    .two {
      img {
        width: 412px;
        height: 343px;
      }
    }
    .three {
      img {
        width: 427px;
        height: 280px;
        margin-top: 30px;
      }
    }
  }
}
.case {
  width: 100%;
  background: #ffffff;
}
.case_main {
  max-width: 1920px;
  margin: 0 auto;
  .case_title {
    height: 180px;
    padding-left: 150px;
    .en {
      font-size: 35px;
      color: #dbdbdb;
      padding-top: 60px;
      line-height: 40px;
    }
    .cn {
      font-size: 39px;
      color: #5373f8;
      letter-spacing: 1px;
      font-weight: bold;
    }
  }
  .grap {
    width: 70px;
    height: 3px;
    background: #5373f8;
    margin-top: -15px;
    margin-left: 150px;
  }
  .case_content {
    width: 100%;
    text-align: center;
    padding-top: 40px;
    img {
      width: 85%;
    }
  }
}
.partner {
  width: 100%;
  padding-top: 60px;
  background: #ffffff;
  .partner_main {
    max-width: 1920px;
    width: 85%;
    min-width: 1600px;
    margin: 0 auto;
    height: 800px;
    background: url("../../assets/img/hezuoab.jpg");
    position: relative;
    .partner_title {
      height: 180px;
      padding-left: 150px;
      .en {
        font-size: 35px;
        color: #686b85;
        padding-top: 60px;
        line-height: 40px;
      }
      .cn {
        font-size: 39px;
        color: #fff;
        letter-spacing: 1px;
        font-weight: bold;
      }
    }
    .garp {
      width: 70px;
      height: 3px;
      background: #ffffff;
      margin-top: -15px;
      margin-left: 150px;
    }
    img {
      width: 100%;
    }
    .one {
      width: 194px;
      height: 104px;
      position: absolute;
      top: 190px;
      left: 52%;
    }
    .tow {
      width: 225px;
      height: 82px;
      position: absolute;
      top: 190px;
      left: 64%;
    }
    .three {
      width: 157.5px;
      height: 106px;
      position: absolute;
      top: 160px;
      left: 78%;
    }
    .four {
      width: 190px;
      height: 89.5px;
      position: absolute;
      top: 330px;
      left: 46%;
    }
    .five {
      width: 251px;
      height: 121px;
      position: absolute;
      top: 330px;
      left: 58.5%;
    }
    .six {
      width: 225px;
      height: 105px;
      position: absolute;
      top: 310px;
      left: 74%;
    }
    .seven {
      width: 183px;
      height: 110px;
      position: absolute;
      top: 460px;
      left: 50%;
    }
    .eight {
      width: 180px;
      height: 92px;
      position: absolute;
      top: 490px;
      left: 63%;
    }
    .nine {
      width: 164.5px;
      height: 115px;
      position: absolute;
      top: 445px;
      left: 75%;
    }
    .ten {
      color: #ffffff;
      position: absolute;
      top: 605px;
      left: 78%;
    }
  }
}
.news {
  width: 100%;
  background: #ffffff;
  .news_main {
    max-width: 1920px;
    width: 80%;
    margin: 0 auto;
    .news_title {
      height: 180px;
      padding-left: 100px;
      .en {
        font-size: 35px;
        color: #dbdbdb;
        padding-top: 60px;
        line-height: 40px;
      }
      .cn {
        font-size: 39px;
        color: #5373f8;
        letter-spacing: 1px;
        font-weight: bold;
      }
    }
    .grap {
      width: 70px;
      height: 3px;
      background: #5373f8;
      margin-top: -15px;
      margin-left: 100px;
    }
    .news_main_menu {
      display: flex;
      padding-top: 60px;
      justify-content: space-around;
      .news_item {
        width: 480px;
        .news_header {
          width: 480px;
          height: 250px;
        }
        .new_body {
          display: flex;
          border: 2px solid #eeeeee;
          border-top: none;
          padding: 30px 20px 30px 0px;
          .new_date {
            width: 120px;
            text-align: center;
            border-right: 1px dashed #666666;
            .new_day {
              font-size: 39px;
              color: #333;
            }
            .new_year {
              color: #666666;
            }
          }
          .new_content {
            width: 230px;
            color: #333333;
            display: flex;
            align-items: center;
            text-indent: 1.45em;
            margin-left: 40px;
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 1440px) {
  .about_title {
    padding-top: 150px;
    font-size: 40px;
    line-height: 60px;
  }
  .about_menu {
    font-size: 16px;
    line-height: 12px;
  }
  .about_menu_item {
    width: 90px;
    height: 25px;
    margin-right: 22px;
  }
}
@media only screen and (max-width: 1200px) {
  .about_title {
    font-size: 30px;
    line-height: 50px;
  }
  .about_menu {
    font-size: 14px;
    line-height: 12px;
  }
  .about_menu_item {
    width: 70px;
    height: 25px;
    margin-right: 19px;
  }
}
</style>
